import { render } from "./View.pug?vue&type=template&id=31751992&ts=true&lang=pug&external"
import script from "./View.ts?vue&type=script&lang=ts&external"
export * from "./View.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/websites/View.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31751992"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31751992', __exports__)) {
    api.reload('31751992', __exports__)
  }
  
  module.hot.accept("./View.pug?vue&type=template&id=31751992&ts=true&lang=pug&external", () => {
    api.rerender('31751992', render)
  })

}


export default __exports__